import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@reach/tooltip/styles.css';
import '@reach/tabs/styles.css';
import '@reach/dialog/styles.css';
import '#/assets/normalize.css';
import '#/assets/base.css';

import TopLevelErrorBoundary from '#/components/TopLevelErrorBoundary';

import App from './App';
import AutoUpdater from './AutoUpdater';

const container = document.getElementById('root');

const root = createRoot(container!);

const AppContent = () => {
  return (
    <>
      <AutoUpdater />
      <TopLevelErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TopLevelErrorBoundary>
    </>
  );
};

if (IS_RUNNING_IN_CYPRESS === 'true') {
  // `cypress-websocket-plugin` package for now does not support strict mode,
  //    where `useEffect` hook is called twice
  // see: https://github.com/coco1979ka/cypress-websocket-plugin/#known-issues
  root.render(<AppContent />);
} else {
  root.render(
    <React.StrictMode>
      <AppContent />
    </React.StrictMode>,
  );
}
